import React from 'react';
import { Text, StyleSheet, View } from 'react-native';
import Colors from '../../../../constants/Colors';
import { occupancyColor } from '../../AreaView';
import Style from '../../../../constants/Style';
import DetailsButton from './DetailsButton';

interface CountWidgetProps {
  occupancy: number,
  limit: number,
  viewDetails?: () => void,
  percent?: number,
}

const CountWidget = ({
  occupancy, limit, viewDetails = null, percent,
}: CountWidgetProps) => {
  const parsedPercent = Number(percent);
  const parsedOccupancy = Number(occupancy);
  const parsedLimit = Number(limit);

  const hasValidPercent = Number.isFinite(parsedPercent);
  let percentage: number = hasValidPercent
    ? Math.round(100 * parsedPercent)
    : Math.round(100 * (parsedOccupancy / parsedLimit));
  if (!Number.isFinite(percentage)) percentage = null;

  const percentLabel = percentage === null ? '-' : `${percentage}%`;
  const barWidth: `${number}%` = percentage === null
    ? '0%'
    : `${Math.max(0, Math.min(100, percentage))}%`;

  return <View style={styles.container}>
    <View style={Style.row}>
      <Text style={styles.title}>{'Occupancy'}</Text>
      <DetailsButton onPress={viewDetails} />
    </View>
    <View style={styles.textSection}>
      <Text style={styles.value}>
        <Text style={{ color: occupancyColor(percentage) }}>
          {Number.isFinite(parsedOccupancy) ? parsedOccupancy : '-'}
        </Text>
        {`/${Number.isFinite(parsedLimit) ? parsedLimit : '-'}`}
      </Text>
      <Text style={styles.percentage}>{percentLabel}</Text>
    </View>
    <View style={[styles.track, { backgroundColor: occupancyColor(percentage, true) }]}>
      <View
        style={[
          styles.bar,
          {
            backgroundColor: occupancyColor(percentage),
            width: barWidth,
          },
        ]}
      />
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    lineHeight: 20,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack500,
  },
  track: {
    height: 16,
    borderRadius: 12,
    width: '100%',
    marginBottom: 16,
    overflow: 'hidden',
  },
  bar: {
    height: '100%',
    borderRadius: 12,
  },
  textSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: 16,
    marginBottom: 8,
  },
  value: {
    fontSize: 36,
    lineHeight: 36,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksWhite700,
  },
  percentage: {
    marginTop: 5,
    fontSize: 12,
    lineHeight: 10,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack500,
  },
});

export default CountWidget;
